import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { Icon } from '@/components';

Vue.use(Vuetify);

export default new Vuetify({
  iconfont: 'mdiSvg',
  theme: {
    themes: {
      light: {
        primary: '#363534',
        secondary: '#FF6600',
        accent: '#FF6600',
        error: '#fe8181',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
      },
    },
  },
  icons: {
    values: {
      documents: {
        component: Icon,
        props: {
          name: 'DOCUMENTS',
        },
      },
      'circle-white': {
        component: Icon,
        props: {
          name: 'CIRCLE_WHITE',
        },
      },
      'plus-in-circle': {
        component: Icon,
        props: {
          name: 'PLUS_IN_CIRCLE',
        },
      },
      'plus-in-circle-orange': {
        component: Icon,
        props: {
          name: 'PLUS_IN_CIRCLE_ORANGE',
        },
      },
      'pin_image': {
        component: Icon,
        props: {
          name: 'PINE_IMAGE',
        },
      },
      'check-in-circle': {
        component: Icon,
        props: {
          name: 'CHECK_IN_CIRCLE',
        },
      },
      'info-icon': {
        component: Icon,
        props: {
          name: 'INFO_ICON',
        },
      },
      'arrow_right_reg': {
        component: Icon,
        props: {
          name: 'ARROW_RIGHT_REG',
        },
      },
      plus: {
        component: Icon,
        props: {
          name: 'PLUS',
        },
      },
      rule_checked: {
        component: Icon,
        props: {
          name: 'RULE_CHECKED',
        },
      },
      rule_unchecked: {
        component: Icon,
        props: {
          name: 'RULE_UNCHECKED',
        },
      },
      close_button: {
        component: Icon,
        props: {
          name: 'CLOSE_BUTTON',
        },
      },
      back_button_arrow: {
        component: Icon,
        props: {
          name: 'BACK_BUTTON_ARROW',
        },
      },
      back_button_arrow_disable: {
        component: Icon,
        props: {
          name: 'BACK_BUTTON_ARROW_DISABLE',
        },
      },
      back_button_arrow_hover: {
        component: Icon,
        props: {
          name: 'BACK_BUTTON_ARROW_HOVER',
        },
      },
      visible: {
        component: Icon,
        props: {
          name: 'VISIBLE',
        },
      },
      visible_off: {
        component: Icon,
        props: {
          name: 'VISIBLE_OFF',
        },
      },
      'checkboxOn': {
        component: Icon,
        props: {
          name: 'ACTIVE',
        },
      },
      'checkboxOff': {
        component: Icon,
        props: {
          name: 'NON_ACTIVE',
        },
      },
      'checkboxOff_Error': {
        component: Icon,
        props: {
          name: 'NON_ACTIVE_ERROR',
        },
      },
      'user_icon': {
        component: Icon,
        props: {
          name: 'USER_ICON',
        },
      },
      'photo-arrow': {
        component: Icon,
        props: {
          name: 'PHOTO_ARROW',
        },
      },
      'cross': {
        component: Icon,
        props: {
          name: 'CROSS',
        },
      },
      'empty_Checkbox': {
        component: Icon,
        props: {
          name: 'EMPTY_CHECKBOX',
        },
      },
      'filters': {
        component: Icon,
        props: {
          name: 'FILTERS',
        },
      },
      'arrow-to-top': {
        component: Icon,
        props: {
          name: 'ARROW_TO_TOP',
        },
      },
      'arrow-to-top-orange': {
        component: Icon,
        props: {
          name: 'ARROW_TO_TOP_ORANGE',
        },
      },
      'arrow-to-bottom': {
        component: Icon,
        props: {
          name: 'ARROW_TO_BOTTOM',
        },
      },
      'empty-catalog': {
        component: Icon,
        props: {
          name: 'EMPTY_CATALOG',
        },
      },
      'tile-view': {
        component: Icon,
        props: {
          name: 'TILE_VIEW',
        },
      },
      'list-view': {
        component: Icon,
        props: {
          name: 'LIST_VIEW',
        },
      },
      'active-tile-view': {
        component: Icon,
        props: {
          name: 'ACTIVE_TILE_VIEW',
        },
      },
      'active-list-view': {
        component: Icon,
        props: {
          name: 'ACTIVE_LIST_VIEW',
        },
      },
      'cross-in-circle': {
        component: Icon,
        props: {
          name: 'CROSS_IN_CIRCLE',
        },
      },
      'sort-mobile': {
        component: Icon,
        props: {
          name: 'SORT_MOBILE',
        },
      },
      'check-icon': {
        component: Icon,
        props: {
          name: 'CHECK_ICON',
        },
      },
      'more-white': {
        component: Icon,
        props: {
          name: 'SHOW_MORE_WHITE',
        },
      },
      'more-orange': {
        component: Icon,
        props: {
          name: 'SHOW_MORE_ORANGE',
        },
      },
      'orange-line': {
        component: Icon,
        props: {
          name: 'ORANGE_LINE',
        },
      },
      'heat-blur': {
        component: Icon,
        props: {
          name: 'HEAT_BLUR',
        },
      },
      'metro-blur': {
        component: Icon,
        props: {
          name: 'METRO_BLUR',
        },
      },
      'security-blur': {
        component: Icon,
        props: {
          name: 'SECURITY_BLUR',
        },
      },
      'metro-orange': {
        component: Icon,
        props: {
          name: 'METRO_ORANGE',
        },
      },
      'tech-orange': {
        component: Icon,
        props: {
          name: 'TECH_ORANGE',
        },
      },
      'heat-orange': {
        component: Icon,
        props: {
          name: 'HEAT_ORANGE',
        },
      },
      'security-orange': {
        component: Icon,
        props: {
          name: 'SECURITY_ORANGE',
        },
      },
      'car-orange': {
        component: Icon,
        props: {
          name: 'CAR_ORANGE',
        },
      },
      'gym-orange': {
        component: Icon,
        props: {
          name: 'GYM_ORANGE',
        },
      },
      'laundry-orange': {
        component: Icon,
        props: {
          name: 'LAUNDRY_ORANGE',
        },
      },
      'dentist-orange': {
        component: Icon,
        props: {
          name: 'DENTIST_ORANGE',
        },
      },
      'cafe-orange': {
        component: Icon,
        props: {
          name: 'CAFE_ORANGE',
        },
      },
      'eat-orange': {
        component: Icon,
        props: {
          name: 'EAT_ORANGE',
        },
      },
      'search-icon': {
        component: Icon,
        props: {
          name: 'SEARCH_ICON',
        },
      },
      'plus-icon': {
        component: Icon,
        props: {
          name: 'PLUS_ICON',
        },
      },
      'minus-icon': {
        component: Icon,
        props: {
          name: 'MINUS_ICON',
        },
      },
      'notification-bell': {
        component: Icon,
        props: {
          name: 'NOTIFICATION_BELL',
        },
      },
      'notification-bell-active': {
        component: Icon,
        props: {
          name: 'NOTIFICATION_BELL_ACTIVE',
        },
      },
      'red-right-arrow': {
        component: Icon,
        props: {
          name: 'RED_RIGHT_ARROW',
        },
      },
      'user-photo': {
        component: Icon,
        props: {
          name: 'USER_PHOTO',
        },
      },
      'edit-pencil': {
        component: Icon,
        props: {
          name: 'EDIT_PENCIL',
        },
      },
      'edit-pencil-big': {
        component: Icon,
        props: {
          name: 'EDIT_PENCIL_BIG',
        },
      },
      'edit-page-save': {
        component: Icon,
        props: {
          name: 'EDIT_PAGE_SAVE',
        },
      },
      'edit-page-cancel': {
        component: Icon,
        props: {
          name: 'EDIT_PAGE_CANCEL',
        },
      },
      'black-cross': {
        component: Icon,
        props: {
          name: 'BLACK_CROSS',
        },
      },
      'pin-icon': {
        component: Icon,
        props: {
          name: 'PIN_ICON',
        },
      },
      'pin-icon-active': {
        component: Icon,
        props: {
          name: 'PIN_ICON_ACTIVE',
        },
      },
      'my-apartments-edit-pencil': {
        component: Icon,
        props: {
          name: 'MY_APARTMENTS_EDIT_PENCIL',
        },
      },
      'my-apartments-add': {
        component: Icon,
        props: {
          name: 'MY_APARTMENTS_ADD',
        },
      },
      'sort-icon': {
        component: Icon,
        props: {
          name: 'SORT_ICON',
        },
      },
      'upload_file_icon': {
        component: Icon,
        props: {
          name: 'UPLOAD_FILES_ICON',
        },
      },
      'delete_icon': {
        component: Icon,
        props: {
          name: 'DELETE_ICON',
        },
      },
      'send-feedback': {
        component: Icon,
        props: {
          name: 'SEND_FEEDBACK',
        },
      },
      'user-avatar': {
        component: Icon,
        props: {
          name: 'USER_AVATAR',
        },
      },
      'orange-bell': {
        component: Icon,
        props: {
          name: 'ORANGE_BELL',
        },
      },
      'delete_icon_white': {
        component: Icon,
        props: {
          name: 'DELETE_ICON_WHITE',
        },
      },
      'empty_Checkbox_big': {
        component: Icon,
        props: {
          name: 'EMPTY_CHECKBOX_BIG',
        },
      },
      'checkboxOn_big': {
        component: Icon,
        props: {
          name: 'CHECKBOX_ON_BIG',
        },
      },
      'orange-attention': {
        component: Icon,
        props: {
          name: 'ORANGE_ATTENTION',
        },
      },
      'check_circle_outline': {
        component: Icon,
        props: {
          name: 'CHECK_CIRCLE_OUTLINE',
        },
      },
      'arrow_right': {
        component: Icon,
        props: {
          name: 'ARROW_RIGHT',
        },
      },
      'arrow_left': {
        component: Icon,
        props: {
          name: 'ARROW_LEFT',
        },
      },
      'send-btn': {
        component: Icon,
        props: {
          name: 'SEND_BTN',
        },
      },
      'bookmark': {
        component: Icon,
        props: {
          name: 'BOOKMARK',
        },
      },
      dialog: {
        component: Icon,
        props: {
          name: 'DIALOG',
        },
      },
      parcel: {
        component: Icon,
        props: {
          name: 'PARCEL',
        },
      },
      storage: {
        component: Icon,
        props: {
          name: 'STORAGE',
        },
      },
      'period-error': {
        component: Icon,
        props: {
          name: 'PERIOD_ERROR',
        },
      },
    },
  },
  breakpoint: {
    thresholds: {
      xs: 791, sm: 1025, md: 1280, lg: 1920,
    },
    scrollBarWidth: 0,
  },
} as any);
